/*
 * Returns the short name of a contact entity.
 */
export function contactToShortName(
  contact:
    | {
        firstName?: string | null;
        lastName?: string | null;
        companyName?: string | null;
      }
    | undefined,
): string {
  // Check
  if (!contact) {
    return '';
  }

  return contact.companyName
    ? `${contact.companyName.trim().replace(/\s+/g, ' ')}`
    : `${
        contact.firstName ? contact.firstName.trim().replace(/\s+/g, ' ') : ''
      }` +
        `${
          contact.lastName
            ? ' ' + contact.lastName.trim().replace(/\s+/g, ' ')
            : ''
        }`;
}
